"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListArticle = ListArticle;
exports.auditFinancePending = auditFinancePending;
exports.createAftersale = createAftersale;
exports.examineAftersale = examineAftersale;
exports.exportSale = exportSale;
exports.getAfterState = getAfterState;
exports.getAfterType = getAfterType;
exports.getCost = getCost;
exports.getMerchantAddress = getMerchantAddress;
exports.getOrderDetail = getOrderDetail;
exports.getRefundAmt = getRefundAmt;
exports.getRefundDelivery = getRefundDelivery;
exports.getRefundDetail = getRefundDetail;
exports.getResponsible = getResponsible;
exports.getSaleDetails = getSaleDetails;
exports.getsaleTrack = getsaleTrack;
exports.saveResponsible = saveResponsible;
exports.submitCompensation = submitCompensation;
exports.submitRefundAmt = submitRefundAmt;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    limit = _ref.limit,
    orderCode = _ref.orderCode,
    page = _ref.page,
    status = _ref.status,
    type = _ref.type,
    orderStatus = _ref.orderStatus;
  var data = {
    limit: limit,
    orderCode: orderCode,
    page: page,
    status: status,
    type: type,
    orderStatus: orderStatus
  };
  return (0, _request.default)({
    url: '/admin/order/aftersale',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 * @param orderNo
 * @constructor
 */
function getOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 创建售后
 * @param {*} data
 * @returns
 */
function createAftersale() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _data = _objectSpread({}, data),
    _data$outSelect = _data.outSelect,
    outSelect = _data$outSelect === void 0 ? [] : _data$outSelect,
    aftersaleType = _data.aftersaleType,
    orderNo = _data.orderNo,
    cash = _data.cash,
    points = _data.points,
    _data$couponId = _data.couponId,
    couponId = _data$couponId === void 0 ? [] : _data$couponId,
    customerAddressRealName = _data.customerAddressRealName,
    customerAddressPhone = _data.customerAddressPhone,
    customerAddressDetail = _data.customerAddressDetail,
    supplierAddressRealName = _data.supplierAddressRealName,
    supplierAddressPhone = _data.supplierAddressPhone,
    supplierAddressDetail = _data.supplierAddressDetail,
    isAudited = _data.isAudited,
    _data$proofImages = _data.proofImages,
    proofImages = _data$proofImages === void 0 ? [] : _data$proofImages,
    reason = _data.reason,
    _data$checkFucard = _data.checkFucard,
    checkFucard = _data$checkFucard === void 0 ? [] : _data$checkFucard,
    _data$cshCardRequest = _data.cshCardRequest,
    cshCardRequest = _data$cshCardRequest === void 0 ? [] : _data$cshCardRequest,
    costRequest = _data.costRequest,
    compensationRequest = _data.compensationRequest,
    pickUpAddressId = _data.pickUpAddressId,
    backAddressId = _data.backAddressId,
    pickUpType = _data.pickUpType;
  // 构建 cshCardRequest 对象
  var resultInfo = {
    items: outSelect,
    aftersale: {
      aftersaleType: aftersaleType,
      orderCode: orderNo,
      cshCardRequest: cshCardRequest,
      // 包含 cshCardRequest 对象
      isAudited: isAudited,
      reason: reason,
      proofImages: proofImages,
      costRequest: costRequest
    }
  };

  // 如果提供了赔付数据，添加到请求中
  if (compensationRequest && aftersaleType === 4) {
    resultInfo.aftersale.compensationRequest = compensationRequest;
    // 赔付类型可以不需要选择商品
    if (!outSelect || outSelect.length === 0) {
      resultInfo.items = []; // 确保 items 为空数组而不是 undefined
    }
  }
  if ([1, 2].includes(aftersaleType)) {
    // 销售商地址（换货、退货时展示）
    resultInfo.aftersale['supplierAddress'] = {
      realName: supplierAddressRealName,
      phone: supplierAddressPhone,
      detail: supplierAddressDetail
    };
  }
  ;
  if (aftersaleType == 2) {
    // 客户地址（换货时展示）
    resultInfo.aftersale['customerAddress'] = {
      realName: customerAddressRealName,
      phone: customerAddressPhone,
      detail: customerAddressDetail
    };
  }
  ;
  if (pickUpAddressId != null && pickUpAddressId !== '') {
    resultInfo.aftersale.pickUpAddressId = pickUpAddressId;
  }
  if (backAddressId != null && backAddressId !== '') {
    resultInfo.aftersale.backAddressId = backAddressId;
  }
  if (pickUpType != null && pickUpType !== '') {
    resultInfo.aftersale.pickupType = pickUpType;
  }
  return (0, _request.default)({
    url: "/admin/order/aftersale",
    method: 'post',
    data: resultInfo
  });
}

/**
 * 获取售后类型
 */
function getAfterType() {
  return (0, _request.default)({
    url: "/admin/order/aftersale/type-options",
    method: 'get'
  });
}

/**
 * 获取售后状态
 */
function getAfterState() {
  return (0, _request.default)({
    url: "/admin/order/aftersale/status-options",
    method: 'get'
  });
}

/**
 * 获取售后详情
 */
function getSaleDetails(id) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/".concat(id),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 创建售后跟踪
 * @param {*} data
 * @returns
 */
function getsaleTrack(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/tracking",
    method: 'post',
    data: data
  });
}
function auditFinancePending(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/finance/audit",
    method: 'post',
    data: data
  });
}

/**
 * 导出售后
 * @param {*} params
 * @returns
 */
function exportSale(params) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/export",
    method: 'get',
    params: params
  });
}

/**
 * 审核售后单
 * @param {*} data
 * @returns
 */
function examineAftersale(data) {
  var _ref2 = data || {},
    cash = _ref2.cash,
    points = _ref2.points,
    _ref2$couponId = _ref2.couponId,
    couponId = _ref2$couponId === void 0 ? [] : _ref2$couponId,
    id = _ref2.id,
    adminReason = _ref2.adminReason,
    auditStatus = _ref2.auditStatus,
    customerAddressRealName = _ref2.customerAddressRealName,
    customerAddressPhone = _ref2.customerAddressPhone,
    customerAddressDetail = _ref2.customerAddressDetail,
    supplierAddressRealName = _ref2.supplierAddressRealName,
    supplierAddressPhone = _ref2.supplierAddressPhone,
    supplierAddressDetail = _ref2.supplierAddressDetail,
    aftersaleType = _ref2.aftersaleType,
    notifyType = _ref2.notifyType,
    _ref2$cshCardRequest = _ref2.cshCardRequest,
    cshCardRequest = _ref2$cshCardRequest === void 0 ? [] : _ref2$cshCardRequest,
    pickUpAddressId = _ref2.pickUpAddressId,
    backAddressId = _ref2.backAddressId,
    _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items;
  var resultInfo = {
    afterRefundInfo: couponId && couponId.length ? {
      cash: cash,
      points: points,
      couponId: couponId
    } : {
      cash: cash,
      points: points
    },
    id: id,
    adminReason: adminReason,
    auditStatus: auditStatus,
    notifyType: notifyType,
    items: items,
    cshCardRequest: cshCardRequest // 包含 cshCardRequest 对象
  };
  if ([1, 2].includes(aftersaleType)) {
    // 销售商地址（换货、退货时展示）
    resultInfo['supplierAddress'] = {
      realName: supplierAddressRealName,
      phone: supplierAddressPhone,
      detail: supplierAddressDetail
    };
  }
  ;
  if (aftersaleType == 2) {
    // 客户地址（换货时展示）
    resultInfo['customerAddress'] = {
      realName: customerAddressRealName,
      phone: customerAddressPhone,
      detail: customerAddressDetail
    };
  }
  ;
  if (pickUpAddressId != null && pickUpAddressId !== '') {
    resultInfo.pickUpAddressId = pickUpAddressId;
  }
  if (backAddressId != null && backAddressId !== '') {
    resultInfo.backAddressId = backAddressId;
  }
  return (0, _request.default)({
    url: "/admin/order/aftersale/audit",
    method: 'put',
    data: resultInfo
  });
}

/**
 * 获取退款信息
 * @param {*} id
 * @returns
 */
function getRefundAmt(id) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/refund/".concat(id),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 *
 * @param {*} data
 * @returns
 */
function submitRefundAmt(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/refund/".concat(data.id),
    method: 'post',
    data: data
  });
}

/**
 * 获取售后单物流
 */
function getRefundDelivery(id) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/delivery/".concat(id),
    method: 'get',
    data: {
      id: id
    }
  });
}

/**
 * 获取退款信息详情
 * @param {String} orderNo - 订单号
 */
function getRefundDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/getRefundDetail",
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 获取商家收货地址列表
 * @param {String|Number} userId
 */
function getMerchantAddress(userId) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/getMerchantAddress",
    method: 'get',
    params: {
      userId: userId
    }
  });
}
/**
 * 获取责任判定计算结果
 */
function getCost(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/getCost",
    method: 'post',
    data: data
  });
}

/**
 * 获取责任判定数据
 */

function getResponsible(id) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/getResponsible",
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 导出售后
 * @param {*} params
 * @returns
 */
function saveResponsible(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/saveResponsible/" + data.id,
    method: 'post',
    data: data
  });
}

/**
 * 提交赔付信息
 * @param {Object} data - 赔付信息数据
 * @param {String} data.id - 售后单ID
 * @param {Object} data.compensationRequest - 赔付请求对象
 * @param {Number} data.compensationRequest.compensationType - 赔付类型
 * @param {Number} data.compensationRequest.compensationAmount - 赔付金额(福豆)
 * @param {String} data.compensationRequest.compensationRemark - 赔付说明
 * @returns {Promise}
 */
function submitCompensation(data) {
  return (0, _request.default)({
    url: "/admin/order/aftersale/compensation/".concat(data.id),
    method: 'post',
    data: data.compensationRequest
  });
}